import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalQuestaoAcaoEnum } from 'src/app/shared/enums/modal-questao-acao.enum';
import * as bootstrap from 'bootstrap';
import { RetornoModalTexto } from 'src/app/shared/interfaces/modals/retorno-modal-texto.interface';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-modal-questao-texto',
  templateUrl: './modal-questao-texto.component.html',
  styleUrl: './modal-questao-texto.component.scss'
})
export class ModalQuestaoTextoComponent {
  readonly modalQuestaoAction = ModalQuestaoAcaoEnum;
  texto: string = "";

  @Input() titulo: string = 'Confirmar Ação';
  @Input() descricao: string = 'Descrição';
  @Input() placeholder: string = '';
  @Input() showCancelar: boolean = false;
  @Input() obrigatorio: boolean = true;
  @Input() mostrarNovaRevisao: boolean = false;
  @Input() descricaoButtonSim: string = "Confirmar";
  @Input() descricaoButtonFechar: string = "Fechar";
  @Input() descricaoButtonCancelar: string = "Cancelar";
  @Input() descricaoButtonNovaRevisao: string = "Gerar Nova Revisão";

  @Output() acaoSelecionada = new EventEmitter<RetornoModalTexto>();

  constructor(private toastr: ToastrService) {}
       
  onSim() {
    var retornoModal: RetornoModalTexto = {acao: ModalQuestaoAcaoEnum.SIM, texto: this.texto}
    this.acaoSelecionada.emit(retornoModal);
    this.fecharModal();
  }
  
  onNao() {
    var retornoModal: RetornoModalTexto = {acao: ModalQuestaoAcaoEnum.NAO, texto: this.texto}
    this.acaoSelecionada.emit(retornoModal);
    this.fecharModal();
  }
  
  onCancelar() {
    var retornoModal: RetornoModalTexto = {acao: ModalQuestaoAcaoEnum.CANCELAR, texto: this.texto}
    this.acaoSelecionada.emit(retornoModal);
    this.fecharModal();
  }

  onSalvar() {
    var retornoModal: RetornoModalTexto = {acao: ModalQuestaoAcaoEnum.SALVAR, texto: this.texto}
    this.acaoSelecionada.emit(retornoModal);
    this.fecharModal();
  }

  onNovaRevisao() {
    if (!this.texto.trim()) {
      this.toastr.warning('A descrição da alteração é obrigatória para gerar uma nova revisão.', 'Atenção');
      return;
    }
    var retornoModal: RetornoModalTexto = {acao: ModalQuestaoAcaoEnum.NOVA_REVISAO, texto: this.texto}
    this.acaoSelecionada.emit(retornoModal);
    this.fecharModal();
  }

  private fecharModal() {
    const modalElement = document.getElementById('modal-questao-texto');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.hide();
      }
    }
  }

  abrirModal() {
    this.texto = '';
    const modalElement = document.getElementById('modal-questao-texto');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
}